<div class="report-tree" [class.collapsed]="isTreeCollapsed">
    <div class="toc-header">
        @if (!isTreeCollapsed) {
        <h2>Table of Contents</h2>
        }
        <img src="/assets/icons/left_panel_close.svg" class="toc-close-desktop" alt="Close"
            (click)="onCloseClicked()" [class.flipped]="IsOutlineClosed" />
        <mat-icon class="toc-close-tablet" (click)="onCloseClicked()">
            close
        </mat-icon>
    </div>
    @if (!isTreeCollapsed) {
    <div class="tree-scroll">

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <mat-tree-node class="toc-node" *matTreeNodeDef="let node" matTreeNodeToggle>
                <div class="node-row">
                    <span class="toc-item" [id]="node.id" (click)="scrollTo(node.id)">{{ node.name }}</span>
                </div>
            </mat-tree-node>

            <mat-nested-tree-node class="toc-node" *matTreeNodeDef="let node; when: hasChild">
                <div class="node-row">
                    <span class="toc-item" [id]="node.id" (click)="scrollTo(node.id)">{{ node.name }}</span>
                    <mat-icon matTreeNodeToggle class="toc-arrow">
                        {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>

                </div>
                <div class="tree-children" *ngIf="treeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                </div>
            </mat-nested-tree-node>
        </mat-tree>
    </div>

    }
</div>